import { now } from './geo'

export interface CacheEntry {
  timestamp: number
}

/**
 * Prune cache entries older than TTL
 */
export function pruneCache<T extends CacheEntry>(
  mapObj: Map<string, T>,
  ttlMs: number
): void {
  const cutoff = now() - ttlMs
  for (const [k, entry] of mapObj.entries()) {
    if (entry.timestamp < cutoff) mapObj.delete(k)
  }
}
